/*
 * @Author: lihaitao
 * @Date: 2018-12-06 11:04:29
 * @Last Modified by: lihaitao
 * @Last Modified time: 2020-01-06 18:45:42
 */
import Vue from 'vue'
import Store from '@store'
const origin = 'https://mk-dev.dustess.com'
const config = {
  name: '尘锋',
  productName: '尘锋营销中心',
  pcLoginMsg1: '尘锋信息 京ICP备17028758号',
  pcLoginMsg2: 'Copyright © 2019 北京尘锋信息技术有限公司 All Rights Reserved',
  url: origin,
  loginLogo: `${origin}/img/loginLogo@2x.png`,
  icon: `${origin}/img/favicon.ico`,
  menuLogo: `${origin}/img/menuLogo@2x.png`,
  menuLogoSmall: `${origin}/img/menuLogoSmall@2x.png`
}

export function initCurrentSystemConfig () {
  Store.commit('system/SET_SYSTEMCONFIG', Vue.prototype.$MKSDK.config)
}
